module.exports = __webpack_public_path__ + "img/checkpoints.f063b848.svg";